import { render } from "./resolution-amendment-truncated-text-display.vue?vue&type=template&id=0ce56abe"
import script from "./resolution-amendment-truncated-text-display.vue?vue&type=script&lang=js"
export * from "./resolution-amendment-truncated-text-display.vue?vue&type=script&lang=js"

import "./resolution-amendment-truncated-text-display.vue?vue&type=style&index=0&id=0ce56abe&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__